import React from "react";
import { Play } from "lucide-react";
import useReveal from "../hooks/useReveal";

export default function VideoMessages({ content = {} }) {
  const { ref, cls } = useReveal();
  return (
    <section className="bg-white py-20">
      <div ref={ref} className={`max-w-[1180px] mx-auto px-6 grid lg:grid-cols-2 gap-14 items-center ${cls}`}>
        <div>
          <h2 className="gp-heading text-[2.3rem] sm:text-[2.8rem]">{content.video_title || "Video personal messages"}</h2>
          <p className="text-[#5a6b80] text-[1.12rem] leading-relaxed mt-5 max-w-[480px]">
            {content.video_text || "With every scheduled emailed gift voucher, your customers can now include a customised video message, providing a special touch for their loved ones to relish upon receiving their digital gift voucher."}
          </p>
          <a href="#features" className="gp-btn-outline inline-block rounded-full px-8 py-3 font-medium mt-8">
            {content.video_cta || "Learn about video messages"}
          </a>
        </div>

        <div className="relative">
          <div className="absolute -inset-6 rounded-[2rem] bg-[#dff2f6] -z-0" />
          <div className="relative rounded-2xl overflow-hidden shadow-[0_25px_70px_rgba(20,30,55,0.22)] group cursor-pointer">
            <img
              src={content.video_image || "https://giftpro.co.uk/wp-content/uploads/2025/09/envelope-photo-gift-videos.webp"}
              alt="Personal video message"
              className="w-full object-cover transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="w-20 h-20 rounded-full bg-white/90 backdrop-blur flex items-center justify-center shadow-xl transition-transform group-hover:scale-110">
                <Play size={30} className="text-[#16243b] ml-1" fill="#16243b" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
